import { MapPinIcon } from "@heroicons/react/24/outline";
import { ActivityLocation, EventLocation } from "../../__generated__/graphql";
import { cn, openGoogleMaps } from "../../lib/utils";
import Map from "../Map";

export default function Location({
  location,
}: {
  location?: EventLocation | ActivityLocation | null;
}) {
  const hasLatitudeAndLongitude =
    location?.location?.latitude && location?.location?.longitude;
  if (!location || !location.location) return null;

  const displayLocation =
    location.location?.label ||
    location.location?.address ||
    location.location?.city ||
    location.location?.zipCode;

  if (!displayLocation) return null;

  const address = ({ className }: { className?: string }) => {
    return (
      <div className="flex flex-col gap-4 w-full">
        <div
          className={cn(
            "flex flex-row gap-2 border border-input rounded-md p-4",
            hasLatitudeAndLongitude && "cursor-pointer hover:opacity-80",
            className
          )}
          onClick={() => {
            if (hasLatitudeAndLongitude) {
              if (!location.location?.latitude || !location.location?.longitude)
                return;

              openGoogleMaps(
                location.location?.latitude,
                location.location?.longitude
              );
            }
          }}
        >
          <MapPinIcon className="w-4 h-4" />
          <div>
            <div className="text-sm font-bold">{location.location?.label}</div>
            <div className="text-sm text-secondary">
              {location.location?.address}
            </div>
            <div className="flex flex-row gap-2 text-secondary">
              {location.location?.zipCode && (
                <div className="text-sm">{location.location.zipCode}</div>
              )}
              {location.location?.city && (
                <div className="text-sm">{location.location.city}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (
    hasLatitudeAndLongitude &&
    location.location?.latitude &&
    location.location?.longitude
  ) {
    return (
      <div className="flex h-[100px]">
        <div className="flex flex-col gap-4 w-fit h-[100px]">
          {address({ className: "h-[100px] rounded-r-none" })}
        </div>
        <Map
          latitude={location.location.latitude}
          longitude={location.location.longitude}
          height="100%"
          width="250px"
          zoom={15}
          className="border border-input rounded-l-none"
        />
      </div>
    );
  }

  return address({ className: "w-fit" });
}
